import { render, staticRenderFns } from "./CopiarCardapioPdv.vue?vue&type=template&id=4535ffab"
import script from "./CopiarCardapioPdv.vue?vue&type=script&lang=js"
export * from "./CopiarCardapioPdv.vue?vue&type=script&lang=js"
import style0 from "./CopiarCardapioPdv.vue?vue&type=style&index=0&id=4535ffab&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports